"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../../bind");
var core_client_1 = require("../../lib/core_client");
var url_helpers_1 = require("../shared/url_helpers");
var map_ajax_to_props_1 = require("../map_ajax_to_props");
var CountrySelector = /** @class */ (function (_super) {
    tslib_1.__extends(CountrySelector, _super);
    function CountrySelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountrySelector.prototype.onCountryChange = function (event) {
        this.props.onChange(event.target.value);
    };
    CountrySelector.prototype.filteredCountries = function () {
        var _this = this;
        if (this.props.allowedCountryCodes) {
            return this.props.countries.filter(function (countryData) {
                return _this.props.allowedCountryCodes.includes(countryData.country_code);
            });
        }
        return this.props.countries;
    };
    CountrySelector.prototype.countriesForSelect = function () {
        var options = this.filteredCountries().map(function (country) {
            return (React.createElement("option", { value: country.country_code, key: country.country_code }, country.name));
        });
        options.unshift(this.emptyCountry());
        return options;
    };
    CountrySelector.prototype.emptyCountry = function () {
        return (React.createElement("option", { value: "", key: "empty-country" }, I18n.t('discovery.shopOnboarding.select')));
    };
    CountrySelector.prototype.render = function () {
        return (React.createElement("select", { id: this.props.id, name: this.props.inputName, onChange: this.onCountryChange, value: this.props.value || '', disabled: this.props.disabled, required: true }, this.countriesForSelect()));
    };
    CountrySelector.defaultProps = {
        disabled: false,
        countries: [],
        allowedCountryCodes: null,
    };
    tslib_1.__decorate([
        bind_1.default
    ], CountrySelector.prototype, "onCountryChange", null);
    return CountrySelector;
}(React.Component));
exports.CountrySelector = CountrySelector;
function fetcher() {
    return core_client_1.default.get(url_helpers_1.default.countriesPath).then(function (response) {
        var countries = response.countries;
        return { countries: countries };
    });
}
// The default export automatically fetches countries,
// and the base CountrySelector is also exported to support
// injecting countries in case they are loaded elsewhere.
exports.default = map_ajax_to_props_1.default(fetcher)(CountrySelector, 'CountrySelector');
//# sourceMappingURL=country_selector.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/country_selector.js
// module id = KEiZ
// module chunks = 20 21 22